import { getMessageFromIframe, removeMessageFromIframe } from '../infrastructure.js';
import { postGenericMessage } from '../messages.js';
import { analyticsEvent } from './analytics.js';
import { resizeIframeHeight, setIframeMinHeight } from './app.js';
import { setCoreFunctions } from './core-imports.js';
/*
  Ne peux être utiliser que par le Front Core et être qu'en un seul exemplaire dans toute l'app
*/
export function microFrontListenerCore({ iframe, router, store, useAnalyticService, coreImports = {}, callbackForMessages, uniqObject, }) {
    setCoreFunctions(coreImports);
    if (typeof window === 'undefined')
        return;
    if (store)
        window.globalStore = store;
    if (router)
        window.parentRouter = router;
    getMessageFromIframe(!iframe || !iframe.href ? window.location.origin : iframe.href, (data) => {
        if (typeof data !== 'object')
            return;
        if ('app' in data && iframe?.id) {
            if ('minHeightCalc' in data.app)
                setIframeMinHeight(iframe.id, data.app.minHeightCalc);
            else
                resizeIframeHeight(iframe.id, data.app.height, data.app.unit);
        }
        if ('message' in data && callbackForMessages) {
            callbackForMessages(data);
        }
        if ('routing' in data && router) {
            if (data.routing.goBack) {
                if (router.options?.history?.state?.back) {
                    router.push({ path: router.options.history.state.back });
                }
                else
                    router.back();
            }
            else {
                try {
                    if (router.resolve(data.routing).name !== 'not-found')
                        router.push(data.routing);
                    else if (window.parent?.parentRouter)
                        window.parent?.parentRouter?.push(data.routing);
                }
                catch {
                    if (window.parent?.parentRouter)
                        window.parent?.parentRouter?.push(data.routing);
                }
            }
        }
        if ('analyticsFct' in data && useAnalyticService) {
            analyticsEvent(data, useAnalyticService);
        }
    }, uniqObject);
}
export function microFrontListener({ callbackForMessages, uniqObject }) {
    microFrontListenerCore({
        callbackForMessages,
        uniqObject,
    });
}
export function removeMicroFrontListener({ iframeHref, uniqObject }) {
    removeMessageFromIframe(iframeHref || window.location.origin, uniqObject);
}
/**
 * @deprecated for B2B MonoRepo => use emitMessageToEventBus
 */
export function emitMessageToChild(microFrontName, { message, data = {} }) {
    postGenericMessage(microFrontName, { message, data });
}
//# sourceMappingURL=index.js.map